import { createStore } from 'vuex'
import { alert } from './store/alert/alert.module'
import { authentication } from './store/authentication/authentication.module'
import { versement } from './store/versement/versement.module'
import { surveillance } from './store/surveillance/surveillance.module'
import { acquisition } from './store/acquisition/acquisition.module'
import { surveillanceTopo } from "./store/surveillanceTopo/surveillanceTopo.module"

export default createStore({
    modules: {
        alert,
        authentication,
        versement,
        surveillance,
        acquisition,
        surveillanceTopo
    }
})
